import type { FaireProductEntity } from "../../entity_types/product";

export const p_34zcssfjxg: FaireProductEntity = {
  token: "p_34zcssfjxg",
  type: "product",
  name: "Peripheral Neuropathy Healing Salve",
  brandToken: "b_3w2x2jy6xw",
  brandName: "Radiant Sun Botanicals",
  imageUrl:
    "https://cdn.faire.com/fastly/c90bb4f55b54d723e967dfdbc7019dcb7aa25617d366976661216865997fb4bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/16aaaf1a7d0f3ea4ed6153c558c788ae5310848a46c02d139e56ff9492d2abb0.jpeg",
    "https://cdn.faire.com/fastly/b38d855a5030d6b50bf4d4b47dc26d3abbe3efeb4dceee46da4d5d9cf4020c75.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "1 oz\n\nRelief from peripheral neuropathy pain and discomfort.  \n\nIngredients:\n\n- fractionated coconut oil\n- rice bran wax\n- castor oil\n- bergamot, clove, eucalyptus, frankincense, ginger, lavender, myrrh, peppermint, and tulsi essential oils ",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:48:40.946Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
